var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-forms-regiter"},_vm._l((_vm.plans),function(plan){return _c('pricing-data',{key:plan.codigo,attrs:{"plan":plan,"planSelected":_vm.planSelected},on:{"update:returnPlanSelected":function($event){_vm.planSelected = $event}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }